// extracted by mini-css-extract-plugin
export var legendIndicator = "_ef-1";
export var legendRight = "_ef-0";